import { Dispatch } from 'redux';
import { IPublicClientApplication } from '@azure/msal-browser';
import { logoutAdUser } from '.';

export const fetchPost = (uri: string, bodyObject: any, bearerToken?: string) =>
  fetchRequest('POST', uri, bodyObject, bearerToken);

export const fetchGet = (uri: string, bearerToken?: string) =>
  fetchEmptyRequest('GET', uri, bearerToken);

export const fetchRequest = (
  method: string,
  uri: string,
  bodyObject: any,
  bearerToken?: string,
) => {
  return fetch(`${uri}`, {
    method: method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${bearerToken}`,
    },
    body: JSON.stringify(bodyObject),
  });
};

export const fetchEmptyRequest = (
  method: string,
  uri: string,
  bearerToken?: string,
) =>
  fetch(`${uri}`, {
    method: method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${bearerToken}`,
    },
  });

// this method controls all error messages displayed to the user that are direct results of http requests (API calls usually)
export const httpError =
  (dispatch?: Dispatch, instance?: IPublicClientApplication) =>
  (response: any): Response => {
    switch (response.status) {
      case 500:
        throw Error('Internal Server Error');
      case 408:
        throw Error('Timeout Error');
      case 401:
        // authentication exceptions
        if (instance) logoutAdUser(instance);
        throw Error(
          'Failed to Sign In. Please try again or contact support if the issue persists.',
        );
      case 403:
        // unauthorized access exceptions from API, showing the error message in the response body
        if (instance) logoutAdUser(instance);
        return response;
      case 404:
        throw Error('We couldn’t find this. Sorry!');
      case 204:
        throw Error('There was no data found...');
      default:
        return response;
    }
  };

export const json = (response: Response): Promise<any> => response.json();
export const blob = (response: Response): Promise<Blob> => response.blob();
